import React, { Component } from 'react'
import iconsFaqArrow from '../../assets/svg/iconsFaqArrow.svg'
import PrimaryTitle from '../../components/PrimaryTitle'
import t from '../../service/translate.service'
import Collapsible from 'react-collapsible'

class LoyaltyFaq extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0)
  }

  render () {
    return (
      <div className='faq-wrap'>
        <PrimaryTitle title='FAQ' />

        <div className='loyalty-subtitle text-center' aria-live="polite">{t.LOYALTY_FAQ_SUBTITLE}</div>

        <Collapsible trigger={(
          <a
            href=''
            onClick={(e) => {
              if (e.key !== 'Tab') {
                e.preventDefault()
              }
            }}
            style={{
              textDecoration: 'none',
              color: 'unset'
            }}
            role="button" aria-expanded="false" aria-controls="faq1"
          >
            <span>{t.FAQ_Q_1}</span>
            <div className='arrow'><img src={iconsFaqArrow} alt={t.EXPAND} /></div>
          </a>)}
          id="faq1"
          aria-labelledby="faq1"
        >
          <p>{t.FAQ_A_1}</p>
        </Collapsible>

        <Collapsible trigger={(
          <a
            href=''
            onClick={(e) => {
              if (e.key !== 'Tab') {
                e.preventDefault()
              }
            }}
            style={{
              textDecoration: 'none',
              color: 'unset'
            }}
            role="button" aria-expanded="false" aria-controls="faq2"
          >
            <span>{t.FAQ_Q_2}</span>
            <div className='arrow'><img src={iconsFaqArrow} alt={t.EXPAND} /></div>
          </a>
        )}
          id="faq2"
          aria-labelledby="faq2"
        >
          <p>{t.FAQ_A_2}</p>
        </Collapsible>

        <Collapsible trigger={(
          <a
            href=''
            onClick={(e) => {
              if (e.key !== 'Tab') {
                e.preventDefault()
              }
            }}
            style={{
              textDecoration: 'none',
              color: 'unset'
            }}
            role="button" aria-expanded="false" aria-controls="faq3"
          >
            <span>{t.FAQ_Q_3}</span>
            <div className='arrow'><img src={iconsFaqArrow} alt={t.EXPAND} /></div>
          </a>)}
          id="faq3"
          aria-labelledby="faq3"
        >
          <p>{t.FAQ_A_3}</p>
        </Collapsible>

        <Collapsible trigger={(
          <a
            href=''
            onClick={(e) => {
              if (e.key !== 'Tab') {
                e.preventDefault()
              }
            }}
            style={{
              textDecoration: 'none',
              color: 'unset'
            }}
            role="button" aria-expanded="false" aria-controls="faq4"
          >
            <span>{t.FAQ_Q_4}</span>
            <div className='arrow'><img src={iconsFaqArrow} alt={t.EXPAND} /></div>
          </a>)}
          id="faq4"
          aria-labelledby="faq4"
        >
          <p>{t.FAQ_A_4}</p>
        </Collapsible>
    
        <div className='loyalty-subtitle text-center' aria-live="polite">{t.LOYALTY_FAQ_TEXT}</div>
      </div>
    )
  }
}

export default LoyaltyFaq
